import { EVALUATION_FORMULA_TOKEN_TYPE_PLACEHOLDER, EVALUATION_FORMULA_TOKEN_TYPE_NUMERIC_VALUE, EVALUATION_FORMULA_TOKEN_TYPE_OPERATOR } from "presentation/model/constants";
import { isNullOrEmpty } from "presentation/utils/functions/generic";


export const generatetokenId = () => {
    return new Date().getTime();
}
// Carrega um item no state
export const getFormulaElements = (rawExpression) => {
    let output = rawExpression.split(',');
    return output;
}

export const elementsToExpression = (elements) => {
    let output = elements.join(',');
    return output;
}

export const getTokenIntValue = (token) => {
    let splited = token.replace(/\{|\}/g, "").split(":");
    return parseInt(splited[1]);
}

export const createTag = (term, id = undefined) => {
    return `${term}${id != undefined ? `:${id}` : ''}`
};

export const checkToken = (counter, term, elements) => {
    let rawTag = createTag(term, counter);

    let existing = elements.filter(x => x.token == rawTag)[0];
    if (!existing) {
        return { token: rawTag, tokenTermIndex: counter };
    } else {
        return checkToken(++counter, term, elements);
    }

}

//---

export const addTerm = (termInfo, currentElements) => {
    let output = currentElements;
    let termIndex = 1;
    let term = termInfo.machineName;

    if (!isNullOrEmpty(term)) {
        let { token, tokenTermIndex } = checkToken(termIndex, term, currentElements);
        termInfo.tokenTermIndex = tokenTermIndex;
        output.push({ displayName: token, token: token, tokenId: generatetokenId(), termInfo: termInfo, tokenType: EVALUATION_FORMULA_TOKEN_TYPE_PLACEHOLDER });
    }
    return output;
}


export const addUniqueTerm = (termInfo, currentElements) => {
    let output = currentElements;
    let term = termInfo.machineName;
    if (!isNullOrEmpty(term)) {
        let tag = createTag(term);
        let existing = output.filter(x => x.token == tag)[0];
        if (!existing) {
            output.push({ displayName: termInfo.displayName, token: tag, tokenId: generatetokenId(), termInfo: termInfo, tokenType: EVALUATION_FORMULA_TOKEN_TYPE_PLACEHOLDER });
        }
    }
    return output;
}


export const addOperator = (operator, currentElements) => {
    let output = currentElements;
    if (!isNullOrEmpty(operator)) {
        output.push({ displayName: operator, token: operator, tokenId: generatetokenId(), tokenType: EVALUATION_FORMULA_TOKEN_TYPE_OPERATOR });
    }
    return output;
}


export const addNumber = (number, currentElements) => {
    let output = currentElements;
    if (!isNullOrEmpty(number)) {
        output.push({ displayName: number, token: number, tokenId: generatetokenId(), tokenType: EVALUATION_FORMULA_TOKEN_TYPE_NUMERIC_VALUE });
    }
    return output;
}

//---

export const removeTag = (tokenId, currentElements) => {
    let output = currentElements.filter((e, i) => e.tokenId != tokenId);
    return output;
}

const formulaComponentFunctions = {
    getFormulaElements,
    elementsToExpression,
    getTokenIntValue,
    addTerm,
    addUniqueTerm,
    addNumber,
    addOperator,
    createTag,
}

export default formulaComponentFunctions;